module.exports = {"data":{"site":{"siteMetadata":{"title":"Burle Marx – Escritório de Paisagismo"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projetos.json
// module id = 588
// module chunks = 48006439568790